
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useOrg } from "@/hooks/useOrg";

export interface ContestSummary {
    id: string;
    name: string;
    slug: string;
    created_at: string;
}

export function useAdminContests() {
    const { org } = useOrg();

    return useQuery({
        queryKey: ["admin-contests", org?.id],
        enabled: !!org?.id,
        queryFn: async () => {
            const { data, error } = await supabase
                .from("contests")
                .select("id, name, slug, created_at")
                .eq("organization_id", org!.id)
                .order("created_at", { ascending: false });

            if (error) {
                console.error("Error fetching contests:", error);
                throw error;
            }

            return data as ContestSummary[];
        },
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
}
